'use es6';

import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import StorefrontSectionMarkerContext from '../../context/StorefrontSectionMarkerContext';

const StorefrontSectionMarker = ({
  children,
  name,
  placementValue,
  active = true
}) => {
  const {
    onMount
  } = useContext(StorefrontSectionMarkerContext);
  useEffect(() => {
    if (active) {
      onMount(name, placementValue);
    }
  }, [active, name, onMount, placementValue]);
  return children || null;
};

StorefrontSectionMarker.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  name: PropTypes.string.isRequired,
  placementValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
export default StorefrontSectionMarker;